export function extractStoreFieldArgs(
  storeFieldName: string
): Record<string, any> {
  // storeFieldName has two formats:
  // 1. `messages:{"channel":"QUESTIONS"}`
  // 2. `messages({"channel":"QUESTIONS"})`
  let argsString = storeFieldName;

  if (argsString.indexOf("(") !== -1) {
    const start = argsString.indexOf("(") + 1;
    const end = argsString.lastIndexOf(")");
    argsString = storeFieldName.substring(start, end);
  } else {
    argsString = storeFieldName.substring(storeFieldName.indexOf(":") + 1);
  }

  if (argsString === storeFieldName) {
    return {};
  }

  try {
    return JSON.parse(argsString);
  } catch (e) {
    if (import.meta.env.MODE === "development") {
      console.warn(
        `[extractStoreFieldArgs] failed to parse storeFieldName '${storeFieldName}'`
      );
    }
    return {};
  }
}
